var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jgile-setting"},[_vm._t("default",null,{"value":_vm.value,"saveSetting":_vm.saveSetting,"deleteSetting":_vm.deleteSetting})],2)}
var staticRenderFns = []

export { render, staticRenderFns }